import React from 'react';
import styled from 'styled-components';
import Select from '@mui/material/Select';

import { SVGIcon } from '../../../BuildingBlocks/SVGIcon';
import { Text } from '../../../BuildingBlocks/Text';
import { mixins, colors } from '../../../css';

export const StyledSelect = styled(Select)`
  && {
    visibility: hidden;
    width: 0;
    height: 0;
    position: relative;
  }
`;

export const StyledMenuText = styled(Text.CopyParagraph)`
  display: inline-block;
`;

const spreadIcon = (props) => (
  <SVGIcon selectedIcon="arrow" iconColor={colors.colorGrey} width="12px" height="12px" {...props} />
);
export const StyledArrow = styled(spreadIcon)`
  position: relative;
  right: ${mixins.pxToRem(-5)};
`;

export const StyledParagraph = styled(Text.CopyParagraph)`
  display: inline-block;
  margin-left: ${mixins.pxToRem(5)};
`;

export const SortContainer = styled.div`
  display: block;
  position: relative;

  &:focus,
  & button:focus {
    outline: none;
  }

  &:first-of-type {
    margin-right: ${mixins.pxToRem(45)};
  }

  &:hover,
  & button:hover {
    cursor: pointer;
  }

  &::after {
    left: 0;
    right: 0;
    bottom: 0; /* Corrects weird issue where the div position isn't accounting for the border */
    content: '';
    position: absolute;
    transform: scaleX(0);
    transition: transform 175ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    transform-origin: left;

    /* Make the border red if we have an error! */
    border-bottom: 2px solid ${colors.colorBlue};
    pointer-events: none;
  }

  &:hover::after {
    transform: scaleX(1);
  }
`;
